// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__p4dtw","footerContainer":"Footer_footerContainer__t_scR","logo":"Footer_logo__Efh4U","info":"Footer_info__L4b7j","copyright":"Footer_copyright__el7Ho"};